import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {openMassUpdateModal} from '../../search/action-creators/search';
import {postRgaMassUpdateRequest} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const setSelectedRga = rgaList => ({
    rgaList,
    type: actions.SET_SELECTED_RGA_LIST_MASS_UPDATE
});

export const onMassUpdateRequest = () =>
    dispatch => {

        dispatch(routerActions.push('/rga/recalled/mass-update/selected-rga'));

    };

export const updateMassUpdateRequest = rgaList =>

        async dispatch => {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await postRgaMassUpdateRequest(rgaList);

                successAlertBar(translate('Mass update request has been successfully submitted.'));

                dispatch(openMassUpdateModal());

            } catch (error) {
            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/rga-selected-mass-update.js